import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { firebaseConfig } from './settings.config';
import { HttpModule } from '@angular/http';
import { BrowserModule } from "@angular/platform-browser";
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { DatabaseServiceProvider } from '../providers/database-service/database-service';
import { CartServiceProvider } from '../providers/cart-service/cart-service';
import { HtmlheadServiceProvider } from '../providers/htmlhead-service/htmlhead-service';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { ModifiersProvider } from '../providers/modifiers/modifiers';
import { FinixServiceProvider } from '../providers/finix-service/finix-service';
import { HttpClientModule } from '@angular/common/http';
import { OrderServicesProvider } from '../providers/order-services/order-services';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule, //.enablePersistence(),
    AngularFireAuthModule,
    BrowserModule,
    HttpModule, //TODO: depreciated, need to update on older service
    HttpClientModule
  ],
  exports: [BrowserModule],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [{ provide: ErrorHandler, useClass: IonicErrorHandler },
    GoogleAnalytics,
    DatabaseServiceProvider,
    CartServiceProvider,
    HtmlheadServiceProvider,
    ModifiersProvider,
    FinixServiceProvider,
    OrderServicesProvider
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts